/** Plain-English date for banners: "November 18". */
const longDate = (value) =>
  new Date(value).toLocaleDateString('en-US', { month: 'long', day: 'numeric' });

/**
 * What the account banner says, from the owner's billing access and the
 * workspace's read-only flag. Null when there is nothing to say.
 */
export function accessBannerContent({ access, readOnly, canManageBilling }, now = Date.now()) {
  if (canManageBilling && access?.state === 'read_only') {
    return {
      tone: 'red',
      text: 'Your organization is read-only because it has no plan. You can still view and download every file, but nothing new can be added.',
      action: { to: '/billing/setup', label: 'Choose a plan' },
    };
  }
  if (canManageBilling && access?.state === 'grace') {
    const what = access.reason === 'comp_ended' ? 'complimentary plan' : 'free trial';
    return {
      tone: 'amber',
      text: `Your ${what} has ended. Choose a plan by ${longDate(access.readOnlyOn)} to keep adding files; after that the account becomes read-only.`,
      action: { to: '/billing/setup', label: 'Choose a plan' },
    };
  }
  if (
    canManageBilling &&
    access?.state === 'comp' &&
    new Date(access.endsOn).getTime() - now <= 14 * 86_400_000
  ) {
    return {
      tone: 'blue',
      text: `Your complimentary plan ends on ${longDate(access.endsOn)}. Choose a plan to keep everything running without a break.`,
      action: { to: '/billing/setup', label: 'Choose a plan' },
    };
  }
  if (readOnly) {
    return {
      tone: 'red',
      text: "This organization is read-only because it has no plan. You can view and download files; ask the organization's owner to choose a plan.",
      action: null,
    };
  }
  return null;
}
